/* eslint-disable global-require */

const home =
    {
        products: [
            {
                name: "Cecy Cantiga",
                src: require("../images/products/cecy-cantiga/featured.png").default,
                href: "/produtos/cecy-cantiga"
            },
            {
                name: "Cecy Frases",
                src: require("../images/products/cecy-frases/featured.png").default,
                href: "/produtos/cecy-frases"
            },
            {
                name: "Colorita",
                src: require("../images/products/colorita/featured.png").default,
                href: "/produtos/colorita"
            },
            {
                name: "Rany Boiadeira",
                src: require("../images/products/rany-boiadeira/featured.png").default,
                href: "/produtos/rany-boiadeira"
            },
            {
                name: "Capy Toy",
                src: require("../images/products/capy-toy/featured.png").default,
                href: "/produtos/capy-toy"
            }
        ],
        news: [
            {
                name: "Rany Boiadeira",
                src: require("../images/products/rany-boiadeira/lamina.png").default,
                href: "/produtos/rany-boiadeira"
            },
            {
                name: "Cecy Frases",
                src: require("../images/products/cecy-frases/lamina.png").default,
                href: "/produtos/cecy-frases"
            },
            {
                name: "Colorita",
                src: require("../images/products/colorita/lamina.png").default,
                href: "/produtos/colorita"
            },
        ]
    };

export default home
